import { cn } from "@/lib/cn";

export interface TabDef {
  value: string;
  label: string;
}

export function Tabs({
  tabs,
  value,
  onChange,
}: {
  tabs: TabDef[];
  value: string;
  onChange: (value: string) => void;
}) {
  return (
    <div className="flex items-center gap-1 border-b border-border mb-5 overflow-x-auto scroll-thin">
      {tabs.map((tab) => (
        <button
          key={tab.value}
          onClick={() => onChange(tab.value)}
          className={cn(
            "flex items-center gap-1.5 px-3.5 py-2.5 text-[12.5px] font-semibold -mb-px border-b-2 whitespace-nowrap transition-all",
            value === tab.value
              ? "text-primary border-primary"
              : "text-text2 border-transparent hover:text-text",
          )}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
